<script lang="ts">
  import type { IOptions, IText } from "./../../ts/Interfaces";
  import TextLine from "./TextLine.svelte";
  import { optionsData } from "./../../ts/Stores";
  import {
    Accordion,
    AccordionItem,
    Button,
    Column,
    Grid,
    Row,
    Tag,
  } from "carbon-components-svelte";
  import { TextNewLine, TrashCan } from "carbon-icons-svelte";

  export let lines: IText[];
  export let sectionName: string;

  let options: IOptions;
  optionsData.subscribe((optionsData) => {
    options = optionsData;
  });

  let lineDefault = lines.length > 0 ? lines[0] : options.textDefaults;

  let addLine = () => {
    let line = JSON.parse(JSON.stringify(lineDefault));
    line.content = "";
    lines = [...lines, line];
  };

  // var textline: TextLine;
  // on:animationend={textline.setfocus}
  // bind:this={textline}

  let deleteLine = (lineNo) => {
    if (lines.length > 1) {
      lines = lines.filter(function (value, index, array) {
        if (index != lineNo) return value;
      });
    }
  };
</script>

<div class="section-name">{sectionName}</div>
<Accordion align="start" size="xl">
  {#each lines as line, c}
    <AccordionItem bind:open={line.expanded}>
      <svelte:fragment slot="title">
        <Grid>
          <Row>
            <Column sm={16} md={6} lg={12}>
              <span style="font-weight:600; font-size: 1rem;">
                Line {c + 1}{#if !line.expanded}: {line.content}{/if}
              </span>
              {#if !line.expanded}
                <div class="setting">
                  Settings:
                  {#if !line.hideIsCurved && !line.isCurved}
                    <Tag>
                      Curved
                      {#if line.counterClockwiseDirection}
                        ,Anti-clockwise
                      {/if}
                    </Tag>
                  {/if}
                  <Tag>
                    {line.font.name}, {line.font.size}pts
                  </Tag>
                  {#if line.font.decoration.toString() !== "None"}
                    <Tag>
                      {line.font.decoration.toString().replace("None,", "")}
                    </Tag>
                  {/if}
                  <Tag>
                    {line.horizontalAlignment}
                  </Tag>
                </div>
              {/if}
            </Column>
            {#if lines.length > 1}
              <Column sm={16} md={2} lg={4}>
                <Button
                  kind="danger-tertiary"
                  size="small"
                  on:click={() => deleteLine(c)}
                  icon={TrashCan}
                >
                  Remove Line
                </Button>
              </Column>
            {/if}
          </Row>
        </Grid>
      </svelte:fragment>
      <TextLine bind:line />
    </AccordionItem>
  {/each}
</Accordion>
<Button
  kind="secondary"
  on:click={addLine}
  icon={TextNewLine}
  class="add-line-btn"
>
  Add a New Line
</Button>
